import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Outlet } from 'react-router-dom';
import clsx from 'clsx';
import { Link, useLocation } from 'react-router-dom';
import { default as styles } from './NavBar.module.scss';
import createNavbarItems from './shared/create-navbar-items';
import { shopConfig } from '@/config/shop-config';

function NavBar({ user }) {
  const { routes, routeSP, routeUsers } = createNavbarItems(user);
  const location = useLocation();
  const [hide, setHide] = useState(true);

  useEffect(() => {
    const callback = () => setHide(true);
    document.addEventListener('click', callback);
    return () => document.removeEventListener('click', callback);
  }, []);

  if (!user?.role?.type) {
    return null;
  }

  return (
    <>
      <div className="grid wide">
        <ul className={clsx(styles.nav, styles.hideOnPhone)}>
          <li>
            <Link to="/">
              <img
                className={styles.logo}
                src={shopConfig.images.logo}
                alt="Logo Quốc Tiến"
              />
            </Link>
          </li>

          {routes.map(({ to, actualTo, text }) => (
            <li key={to}>
              <Link
                className={clsx(styles.navBtn, {
                  [styles.active]: location.pathname.startsWith(to),
                })}
                to={actualTo || to}
              >
                {text}
              </Link>
            </li>
          ))}

          <li
            onClick={(e) => {
              e.stopPropagation();
              setHide(!hide);
            }}
          >
            <i className="fas fa-user" />
            <h3 className={styles.greeting}>
              Xin chào{' '}
              {user?.role?.type === 'staff'
                ? `${user.role.name?.toLowerCase() || ''} `
                : ''}
              {user?.displayName}
            </h3>

            <ul
              className={clsx(styles.userOptions, {
                [styles.hide]: hide,
              })}
            >
              {routeUsers.map(({ actualTo, to, text }) => (
                <li className={styles.userOption} key={to}>
                  <Link
                    className={clsx(styles.userLink)}
                    to={actualTo || to}
                  >
                    {text}
                  </Link>
                </li>
              ))}
            </ul>
          </li>
        </ul>

        {/* Phone interface */}
        <ul className={clsx(styles.nav, styles.showOnPhone)}>
          <li>
            <Link to="/">
              <img
                className={styles.logo}
                src={shopConfig.images.logo}
                alt="Logo Quốc Tiến"
              />
            </Link>
          </li>

          <div className={clsx(styles.btnWrapper)}>
            <i
              className="fa-solid fa-bars"
              onClick={(e) => {
                e.stopPropagation();
                setHide(!hide);
              }}
            ></i>

            <ul
              className={clsx(styles.btns, {
                [styles.hide]: hide,
              })}
            >
              {routeSP.map(({ to, actualTo, text }) => (
                <li key={to}>
                  <Link
                    className={clsx(styles.navBtn, {
                      [styles.active]:
                        location.pathname.startsWith(to),
                    })}
                    to={actualTo || to}
                  >
                    {text}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </ul>
      </div>
      <Outlet />
    </>
  );
}

export default connect(({ state }) => ({
  user: state.user,
}))(NavBar);
